<div class="container-fluid" style="margin-bottom: 50px;">
  <div class="container pt-4">
    <div style="font-size: 22px !important;
        font-weight: 400;cursor: pointer;">
      <span>
        <i class="fa fa-tachometer" style="color:#800000"></i>&nbsp;&nbsp;Dashboard
      </span>
    </div>


    <div class="row pt-2">
      <div class="col-md-2 "  *ngIf="hasAccess('Notifications')">
        <div class="card" style="height: 78px;">
          <div class="row" style="margin-top: 12px;">
          </div>
          <div class="row">
            <div class="col-md-2" style=" margin-left: 12px;"><i class="fa fa-bullhorn" style="color:#f29811;"></i>
            </div>
            <div class="col-md-6 cardHeader headingFont" style="color: #800000;  ">&nbsp;
              Notification
            </div>
          </div>
          <div class="row" [routerLink]="userDocStatus ? '/dashboard/manage-announcement' : null">
            <div class="col-md-12" style="text-align: center;">
              <span class="card-content" style="color:#f29811">{{announcementCount}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="['Partner','Managing Partner','Designated Partner'].includes(userRole) && hasAccess('Partners Diaries')">
        <!-- <div class="card cardStyle1">  
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Pending Diaries
              </div>
            </div>
            <hr/>
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader">Self</div>
              <div class="col-md-4 cardHeader">Team</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">To Fill</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ pendingDiariesWeekCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ pendingDiariesWeekTeam || 0 }}
                </span>
              </div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">To Approve</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ pendingDiaryApproval || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ pendingDiaryApprovalTeam || 0 }}
                </span>
              </div>

            </div>
          </div>
        </div> -->
        <div class="card">
          <!-- <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left" type="button" id="Coll" data-toggle="collapse"
                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Financials
              </button>
            </h2>
          </div> -->
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div class="" style="text-align: center">
              <div class="row col-md-12 m-0 p-0">
                <div class="col-md-6 right-border headingFont" style=" background-color: white; color: #800000; ">
                  Pending Diaries Self
                </div>
                <div class="col-md-6 right-border headingFont" style=" background-color: white; color: #800000; ">
                  Pending Diaries Team
                </div>
                <div class="row col-md-12 m-0 p-0 border">
                  <div class="col-md-3 right-border customDashbord" routerLink="/dashboard/my-pending-submission">
                    To fill
                  </div>
                  <div class="col-md-3 right-border customDashbord"
                    [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                    To Approve
                  </div>
                  <div class="col-md-3 right-border customDashbord" (click)="onToFillTeamDiaryClick()">
                    To fill
                  </div>
                  <div class="col-md-3 right-border customDashbord"
                    [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                    To Approve
                  </div>
                </div>
              </div>

              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-3 right-border" routerLink="/dashboard/my-pending-submission">
                  <span class="card-content" style="color: #800000;">
                    {{ pendingDiariesWeekCount || 0 }}
                  </span>
                </div>
                <div class="col-md-3 right-border"
                  [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                  <span class="card-content" style="color: #800000;">
                    {{ pendingDiaryApproval || 0 }}
                  </span>
                </div>
                <div class="col-md-3 right-border" (click)="onToFillTeamDiaryClick()">
                  <span class="card-content" style="color: #800000;">
                    {{ pendingDiariesWeekTeam || 0 }}
                  </span>
                </div>
                <div class="col-md-3 right-border"
                  [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                  <span class="card-content" style="color: #800000;">
                    {{ pendingDiaryApprovalTeam || 0 }}
                  </span>
                </div>
              </div>
              <!-- <div class="row col-md-12 m-0 p-0">
                    <div class="row col-md-12 m-0 p-0"
                      *ngFor="let clist of mis.misDetails.financialsData; let i = index">
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-1 right-border"
                          style="max-width: 5%;text-align: center;font-weight: bold;padding: 0px;">
                          {{ i + 1 }}
                        </div>
                        <div class="col-md-5 right-border" style="font-size: smaller; word-break: keep-all">
                          {{ clist.variable }}
                        </div>
                        <div class="col-md-3 right-border">
                          <input type="number" class="form-control form-control-xs" [disabled]="mis.status === 'Submitted'" [(ngModel)]="clist.amount"
                            (change)="calculateEndOfQuarter()" id="quantity" name="quantity" min="0"/>
                        </div>
                        <div class="col-md-3">
                          <input type="text" [(ngModel)]="clist.remark" [disabled]="mis.status === 'Submitted'" id="remark_{{ i }}" name="remark_{{ i }}"
                            class="form-control form-control-xs" [class.is-invalid]="
                                                              clist.remark?.required " matTooltip=""
                            matTooltipPosition="above" />
                        </div>
                      </div>
                    </div>
                  </div> -->

            </div>
          </div>
        </div>
      </div>



      <div class="col-md-4" *ngIf="['Partner','Managing Partner','Designated Partner'].includes(userRole) && hasAccess('Partners Travel Claims')">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-book" style="color:green"></i></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Pending Travel Claim
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-6 right-border customDashbord" routerLink="/dashboard/travel-sheet">
                My Claim
              </div>
              <div class="col-md-6 right-border customDashbord"
                routerLink="/dashboard/my-pending-travel-sheet-approvals">
                To Approve
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-6 right-border" routerLink="/dashboard/travel-sheet">
              <span class="card-content" style="color:#800000">{{unapprovedTsheetAmount| number: '2.'}}</span>
            </div>
            <div class="col-md-6 right-border" routerLink="/dashboard/my-pending-travel-sheet-approvals">
              <span class="card-content" style="color:#800000">{{pendingTsheetApproval| number: '2.'}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="card cardStyle1" style="cursor: pointer;">
          <div class="card-body align-items-start">

            <div class="row">
              <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Pending Travel Claim
              </div>
            </div>

            <div class="row mt-3" routerLink="/dashboard/travel-sheet">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
              My Claim&nbsp;<span class="card-content" style="color:#17a2b8">{{unapprovedTsheetAmount| number: '2.'}}</span>
              </div>
              <div class="col-md-1"></div>
            </div>

            <div class="row mt-3"  [routerLink]="checkApproverforRoute?['/dashboard/my-pending-travel-sheet-approvals']:[]">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
              To Approve &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingTsheetApproval| number: '2.'}}</span>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div> -->
      </div>




      <!-- display to everyone excluding manager partner -->
      <div class="col-md-3" *ngIf="userRole!='Partner' && hasAccess('Users Pending Diaries')">
        <div class="card cardStyle1">
          <div class="card-body align-items-start">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Pending Diaries
              </div>
            </div>

            <div class="row mt-3" [routerLink]="userDocStatus ? '/dashboard/my-pending-submission' : null">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                To Fill &nbsp;<span class="card-content"
                  style="color:#17a2b8">{{pendingDiariesWeekCount}}</span>&nbsp;Weeks
              </div>
              <div class="col-md-1"></div>
            </div>

            <div class="row mt-3" [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                To Approve &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingDiaryApproval}}</span>
              </div>
              <div class="col-md-1"></div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-3" *ngIf="userRole!='Partner' && hasAccess('Users Travel Claims')">
        <div class="card cardStyle1" style="cursor: pointer;">
          <div class="card-body align-items-start">

            <div class="row">
              <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Pending Travel Claim
              </div>
            </div>

            <div class="row mt-3" [routerLink]="userDocStatus ? '/dashboard/travel-sheet' : null">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                Claim Rs.&nbsp;<span class="card-content" style="color:#17a2b8">{{unapprovedTsheetAmount| number:
                  '2.'}}</span>
              </div>
              <div class="col-md-1"></div>
            </div>

            <div class="row mt-3"
              [routerLink]="checkApproverforRoute?['/dashboard/my-pending-travel-sheet-approvals']:[]">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                Approve Claim Rs. &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingTsheetApproval|
                  number: '2.'}}</span>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" *ngIf="userRole!='Partner' && hasAccess('Users Penalty')">
        <div class="card">
          <div class="card-body align-items-start">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-ban" style="color:#f21118"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Penalty As On Today
              </div>
            </div>

            <div class="row mt-3" [routerLink]="userDocStatus ? '/dashboard/my-penalty-summary' : null">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                <span>Penalty Charged </span><br><span class="card-content"
                  style="color:#800000">{{penaltyCharged}}</span>
              </div>
            </div>
            <div class="row mt-3" [routerLink]="userDocStatus ? '/dashboard/my-penalty-summary' : null">
              <div class="col-md-1"></div>
              <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                <span>Penalty Uncharged </span><br><span class="card-content"
                  style="color:#800000">{{penaltyUncharged}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- display to partners only excluding manager partner -->
    <div class="row pt-2">
      <div class="col-md-5 mt-4" *ngIf=" ['Partner','Managing Partner','Designated Partner'].includes(userRole) && hasAccess('Partners Penalty')">
        <!-- <div class="card cardStyle1">
          
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-book" style="color:#800000"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Penalty
              </div>
            </div>
            <hr/>
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-2"></div>
              <div class="col-md-5 cardHeader">Self</div>
              <div class="col-md-5 cardHeader">Team</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-2 cardHeader">Charged</div>
              <div class="col-md-5">
                <span class="card-content" style="color:#800000">
                  {{ penaltyCharged || 0 }}
                </span>
              </div>
              <div class="col-md-5">
                <span class="card-content" style="color:#800000">
                  {{ penaltyChargedTeam || 0 }}
                </span>
              </div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-2 cardHeader">Current</div>
              <div class="col-md-5">
                <span class="card-content" style="color:#800000">
                  {{ penaltyUncharged || 0 }}
                </span>
              </div>
              <div class="col-md-5">
                <span class="card-content" style="color:#800000">
                  {{ penaltyUnchargedTeam || 0 }}
                </span>
              </div>

            </div>
          </div>
        </div> -->
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div class="" style="text-align: center" routerLink="/dashboard/my-penalty-summary">
              <div class="row col-md-12 m-0 p-0" style="  background-color: #800000; color: white; ">
                <div class="col-md-6 right-border headingFont" style=" background-color: white; color: #800000; ">
                  Penalty Self
                </div>
                <div class="col-md-6 right-border headingFont" style=" background-color: white; color: #800000; ">
                  Penalty Team
                </div>
                <div class="row col-md-12 m-0 p-0 border">
                  <div class="col-md-3 right-border customDashbord">
                    Charged
                  </div>
                  <div class="col-md-3 right-border customDashbord">
                    Current
                  </div>
                  <div class="col-md-3 right-border customDashbord">
                    Charged
                  </div>
                  <div class="col-md-3 right-border customDashbord">
                    Current
                  </div>
                </div>
              </div>

              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-3 right-border">
                  <span class="card-content" style="color:#800000">
                    {{ penaltyCharged | indianNumber}}
                  </span>
                </div>
                <div class="col-md-3 right-border">
                  <span class="card-content" style="color:#800000">
                    {{ penaltyUncharged | indianNumber}}
                  </span>
                </div>
                <div class="col-md-3 right-border">
                  <span class="card-content" style="color:#800000">
                    {{ penaltyChargedTeam | indianNumber}}
                  </span>
                </div>
                <div class="col-md-3 right-border">
                  <span class="card-content" style="color:#800000">
                    {{ penaltyUnchargedTeam | indianNumber}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-4" *ngIf=" ['Partner','Managing Partner','Designated Partner'].includes(userRole) && hasAccess('Partners Leaves')">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
            <div class="col-md-9 cardHeader headingFont" style=" background-color: white; color: #800000; ">&nbsp;
              Leave Current Year
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-3 right-border customDashbord" routerLink="/dashboard/my-leaves">
                Taken
              </div>
              <div class="col-md-4 right-border customDashbord" routerLink="/dashboard/my-leaves">
                Balance
              </div>
              <div class="col-md-5 right-border customDashbord"
                [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                To Approve
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-3" routerLink="/dashboard/my-leaves">
              <span class="card-content" style="color:#800000">
                {{ partnersDashboardLeave.taken || 0 }}
              </span>
            </div>
            <div class="col-md-4" routerLink="/dashboard/my-leaves">
              <span class="card-content" style="color:#800000">
                {{ partnersDashboardLeave.balance || 0 }}
              </span>
            </div>
            <div class="col-md-5" [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
              <span class="card-content" style="color:#800000">
                {{ partnersDashboardLeave.toApprove || 0 }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="card cardStyle1">
          
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Leave current year
              </div>
            </div>
            <hr/>
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4 cardHeader">Taken</div>
              <div class="col-md-4 cardHeader">Balance</div>
              <div class="col-md-4 cardHeader">To Approve</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4">
                <span class="card-content" style="color:#17a2b8">
                  {{ partnersDashboardLeave.taken || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#17a2b8">
                  {{ partnersDashboardLeave.balance || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#17a2b8">
                  {{ partnersDashboardLeave.toApprove || 0 }}
                </span>
              </div>
            </div>

            
          </div>
        </div> -->
      </div>
      <div class="col-md-3 mt-4" *ngIf="['Partner','Managing Partner','Designated Partner'].includes(userRole) && hasAccess('Overtime Paid')">
        <!-- <div class="card cardStyle1">
          
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Overtime paid
              </div>
            </div>
            <hr/>
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-6 cardHeader">2023-24</div>
              <div class="col-md-6 cardHeader">2022-23</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6">
                <span class="card-content" style="color:darkviolet">
                  {{ overtimePaid || 0 }}
                </span>
              </div>
              <div class="col-md-6">
                <span class="card-content" style="color:darkviolet">
                  {{ overtimePaidPy || 0 }} 
                </span>
              </div>
            </div>

          </div>
        </div> -->
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
            <div class="col-md-9 cardHeader headingFont" style=" background-color: white; color: #800000; ">&nbsp;
              Overtime Paid
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-6 right-border customDashbord">
                {{CY}}
              </div>
              <div class="col-md-6 right-border customDashbord">
                {{PY}}
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-6">
              <span class="card-content" style="color:#800000">
                {{ overtimePaid | indianNumber}}
              </span>
            </div>
            <div class="col-md-6">
              <span class="card-content" style="color:#800000">
                {{ overtimePaidPy | indianNumber}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-1" *ngIf=" (hasAccess('Head Count') || hasAccess('Assets Count'))">


      <div class="col-md-6 mt-4" *ngIf="hasAccess('Head Count')">
        <!-- <div class="row pt-1">
          <div class="col-md-12">
            <div class="card cardStyle1">
              <div class="card-body align-items-start ml-4 mr-4">
                <div class="row pb-2" style="text-align: center;">
                  <div class="col-md-4"></div>
                  <div class="col-md-4 cardHeader">
                    <div class="row pb-2">
                      <div class="col-md-1"></div>
                      <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                      <div class="col-md-9 cardHeader">&nbsp;
                        Head count Firm
                      </div>
                      <div class="col-md-1"></div>
                    </div>
                  </div>
                  <div class="col-md-4 cardHeader">
                    <div class="row pb-2">
                      <div class="col-md-1"></div>
                      <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                      <div class="col-md-9 cardHeader">&nbsp;
                        Head count {{branchName}}
                      </div>
                      <div class="col-md-1"></div>
                    </div>
                  </div>
                </div>

                <div class="row" style="text-align: center;background-color: #f2f2f2;">
                  <div class="col-md-4 cardHeader">Employees</div>
                
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ employeeFirmCount || 0}}
                    </span>
                  </div>
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ employeePuneCount || 0 }}
                    </span>
                  </div>
                </div>

                <div class="row mt-0 mb-1" style="text-align: center;background-color: #f2f2f2;">
                  <div class="col-md-4 cardHeader">Articles</div>
                  
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ articleFirmCount || 0 }}
                    </span>
                  </div>
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ articlePuneCount || 0 }}
                    </span>
                  </div>

                </div>

                <div class="row mt-0 " style="text-align: center;background-color: #f2f2f2;">
                  <div class="col-md-4 cardHeader">Consultants</div>
                  
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ consultantFirmCount || 0 }}
                    </span>
                  </div>
                  <div class="col-md-4">
                    <span class="card-content" style="color: green;">
                      {{ consultantPuneCount || 0 }}
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0">
              <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                  Head Count Firm
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-4 right-border customCardStyle  " >
                  Employees
                </div>
                <div class="col-md-4 right-border customCardStyle  " >
                  Articles
                </div>
                <div class="col-md-4 right-border customCardStyle  " >
                  Consultants
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ employeePuneCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ articlePuneCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ consultantPuneCount || 0 }}
                </span>
              </div>
            </div> 
          </div>   -->

        <div class="card cardStyle1">
          <div class="card-body align-items-start ">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader headingFont"
                style="font-size: small; background-color: white; color: #800000; ">Head Count</div>
            </div>
            <div class="row" style="text-align: center; ">
              <div class="col cardHeader" style="font-size: small;">Particulars</div>
              <div class="col cardHeader" style="font-size: small;">Firm</div>
              <div class="col cardHeader" style="font-size: small;">{{branchName}}</div>

            </div>

            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Employee
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{employeeFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{employeePuneCount}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Consultant
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{consultantFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{consultantPuneCount}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Article
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{articleFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{articlePuneCount}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small;">
                  Total
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; ">
                  {{totalFirmHeadCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small;">
                  {{totalBranchHeadCount}}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-6 mt-4" *ngIf="hasAccess('Assets Count')">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader headingFont"
                style="font-size: small; background-color: white; color: #800000; ">Asset Count</div>
            </div>
            <div class="row " style="text-align: center;">
              <div class="col cardHeader" style="font-size: small;">Particulars</div>
              <div class="col cardHeader" style="font-size: small;">Firm</div>
              <div class="col cardHeader" style="font-size: small;">{{branchName}}</div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Laptop
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{laptopAssetFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{laptopAssetPuneCount}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Assigned
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assignedAssetFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assignedAssetPuneCount}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Instock
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{instockAssetFirmCount}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{instockAssetPuneCount}}
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>


      <!-- <div class="col-md-6">
        <div class="card" style="text-align: center" >
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
              <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                Head Count {{branchName}}
              </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Employees
              </div>
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Articles
              </div>
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Consultants
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ employeeFirmCount || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ articleFirmCount || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ consultantFirmCount || 0 }}
              </span>
            </div>
          </div> 
        </div>  
      </div>   -->
      <!-- <div class="col-md-6">
    <div class="row pt-1">  
      <div class="col-md-12">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-3"></div>
              <div class="col-md-4 cardHeader">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Assets Count Firm
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
              <div class="col-md-5 cardHeader">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;&nbsp;
                    Assets Count {{branchName}}
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Laptops</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ laptopAssetFirmCount || 0}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ laptopAssetPuneCount || 0 }}
                </span>
              </div>
            </div>

            <div class="row mt-1 mb-0" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Assigned</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ assignedAssetFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ assignedAssetPuneCount || 0 }}
                </span>
              </div>

            </div>

            <div class="row mt-1 mb-0" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Admin</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ instockAssetFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ instockAssetPuneCount || 0 }}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>     -->

      <!-- <div class="col-md-6">
        <div class="card customCardStyle">
          <div class="card-body align-items-start ">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader">Contribution CY</div>
              <div class="col-md-4 cardHeader">Contribution PY</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Fees</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYFees| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYFees| number: '2.'}}
                </span>
              </div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Fees</div>
              
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{actualFees| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualFees| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Cost</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYBudgetedCost| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYBudgetedCost| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Cost</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYActualCost| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualCost| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Contribution</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYBudgetedContri| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYBudgetedContri| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Contribution</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYActualContri| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualContri| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Contribution %</div>
              
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{budgetedContributionCYPercentage| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{budgetedContributionPYPercentage| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Contribution %</div>
            
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYPercentage| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYPercentage| number: '2.'}}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- asset count -->

    <div class="row pt-1" *ngIf="checkHRRole || checkPartnerRole">


      <!-- <div class="col-md-6">
       
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0">
              <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                  Assets Count Firm
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  Laptops
                </div>
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  Assigned
                </div>
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  Admin
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ laptopAssetFirmCount || 0}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ assignedAssetFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ instockAssetFirmCount || 0 }}
                </span>
              </div>
            </div> 
          </div>  
      </div>

      <div class="col-md-6">
        <div class="card" style="text-align: center" >
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
              <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                Assets Count {{branchName}}
              </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Laptops
              </div>
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Assigned
              </div>
              <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                Admin
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ laptopAssetPuneCount || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ assignedAssetPuneCount || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ instockAssetPuneCount || 0 }}
              </span>
            </div>
          </div> 
        </div>  
      </div>   -->
      <!-- <div class="col-md-6">
    <div class="row pt-1">  
      <div class="col-md-12">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-3"></div>
              <div class="col-md-4 cardHeader">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Assets Count Firm
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
              <div class="col-md-5 cardHeader">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;&nbsp;
                    Assets Count {{branchName}}
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Laptops</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ laptopAssetFirmCount || 0}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ laptopAssetPuneCount || 0 }}
                </span>
              </div>
            </div>

            <div class="row mt-1 mb-0" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Assigned</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ assignedAssetFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ assignedAssetPuneCount || 0 }}
                </span>
              </div>

            </div>

            <div class="row mt-1 mb-0" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Admin</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ instockAssetFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ instockAssetPuneCount || 0 }}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>     -->

      <!-- <div class="col-md-6">
        <div class="card customCardStyle">
          <div class="card-body align-items-start ">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader">Contribution CY</div>
              <div class="col-md-4 cardHeader">Contribution PY</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Fees</div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYFees| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYFees| number: '2.'}}
                </span>
              </div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Fees</div>
              
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{actualFees| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualFees| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Cost</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYBudgetedCost| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYBudgetedCost| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Cost</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYActualCost| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualCost| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Contribution</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYBudgetedContri| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYBudgetedContri| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Contribution</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYActualContri| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYActualContri| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Budgeted Contribution %</div>
              
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{budgetedContributionCYPercentage| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{budgetedContributionPYPercentage| number: '2.'}}
                </span>
              </div>

            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Actual Contribution %</div>
            
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionCYPercentage| number: '2.'}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{contributionPYPercentage| number: '2.'}}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- <div class="row pt-1" *ngIf="checkPartnerRole">
          
      </div> -->

    <div class="pt-3" *ngIf="HrRoleActive">
      <div class="row">
        <!-- <div class="col-md-4">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row pb-2">
                <div class="col-md-1"></div>
                <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Head count Firm
                </div>
                <div class="col-md-1"></div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Employees </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{employeeFirmCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Articles </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{articleFirmCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Consultants </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{consultantFirmCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row pb-2">
                <div class="col-md-1"></div>
                <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Head count {{branchName}}
                </div>
                <div class="col-md-1"></div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Employees </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{employeePuneCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Articles </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{articlePuneCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Consultants </span>&nbsp;&nbsp;<span class="card-content" style="color: orange;">{{consultantPuneCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->


        <div class="col-md-6" *ngIf="hasAccess('Reminders')">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row pb-2">
                <div class="col-md-4"></div>
                <div class="col-md-1"><i class="fa fa-bell" style="color:violet"></i></div>
                <div class="col-md-5 cardHeader">&nbsp;
                  Reminders
                </div>
                <div class="col-md-3"></div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;"
                  routerLink="/dashboard/probation-complete-report">
                  <span>Probation </span>&nbsp;&nbsp;<span class="card-content"
                    style="color: violet;">{{probationCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;"
                  routerLink="/dashboard/articleship-end-report">
                  <span>Articleship end </span>&nbsp;&nbsp;<span class="card-content"
                    style="color: violet;">{{articleshipEndCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;"
                  routerLink="/dashboard/consultants-end-report">
                  <span>Consultants end </span>&nbsp;&nbsp;<span class="card-content"
                    style="color: violet;">{{consultantEndCount}}</span>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;"
                  routerLink="/dashboard/work-anniversaey-report">
                  <span>Work Anniversary </span>&nbsp;&nbsp;<span class="card-content"
                    style="color: violet;">{{workAnniversaryCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-4">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row pb-2">
                <div class="col-md-3"></div>
                <div class="col-md-1"><i class="fa fa-bell" style="color:violet"></i></div>
                <div class="col-md-5 cardHeader">&nbsp;
                  Reminders
                </div>
                <div class="col-md-3"></div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Probation </span>&nbsp;&nbsp;<span class="card-content" style="color: violet;">{{probationCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Articleship end </span>&nbsp;&nbsp;<span class="card-content" style="color: violet;">{{articleshipEndCount}}</span>
                </div>
              </div>

              <div class="row pb-3">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Consultants end </span>&nbsp;&nbsp;<span class="card-content" style="color: violet;">{{consultantEndCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-md-2" *ngIf="hasAccess('Article Vacancy')">
          <div class="card cardStyle">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-hourglass-end" style="color:indigo"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Article vaccancy
                </div>
              </div>

              <div class="row mt-2" routerLink="/dashboard/article-vacancy">
                <div class="col-md-12" style="text-align: center; margin-top: 25px;">
                  <span class="card-content" style="color:indigo">{{articleVaccancyCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" *ngIf="hasAccess('Incomplete Profiles')">
          <div class="card cardStyle">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-user-times" style="color:maroon"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Incomplete profile
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12" style="text-align: center;  margin-top: 25px;"
                  routerLink="/dashboard/incomplete-profiles">
                  <span class="card-content" style="color:maroon;">{{incompleteProfileCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" *ngIf="hasAccess('Users Balance Leaves')">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Balance leave
                </div>
              </div>

              <div class="row mt-3" routerLink="/dashboard/my-leaves">
                <div class="col-md-12" style="text-align: center;  margin-top: 25px;">
                  <span class="card-content" style="color:#17a2b8">{{leaveBalanceCount}}</span>&nbsp;
                  <span>Days</span>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-2" *ngIf="checkPartnerRole">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Overtime Paid
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12" style="text-align: center;  margin-top: 25px;">
                  <span class="card-content" style="color:darkviolet">{{overtimePaid| number: '2.'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="pt-2">
        <div class="row">
          <!-- <div class="col-md-4">
            <div class="card cardStyle1">
              <div class="card-body align-items-start">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Assets Count Firm
                  </div>
                  <div class="col-md-1"></div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Laptops </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{laptopAssetFirmCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Assigned </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{assignedAssetFirmCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Admin </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{instockAssetFirmCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
   

          <div class="col-md-4">
            <div class="card cardStyle1">
              <div class="card-body align-items-start">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Assets Count {{branchName}}
                  </div>
                  <div class="col-md-1"></div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Laptops </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{laptopAssetPuneCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Assigned </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{assignedAssetPuneCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Admin </span>&nbsp;&nbsp;<span class="card-content" style="color: blue;">{{instockAssetPuneCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->



        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-md-6">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader">
                <div class="row pb-2">
                <div class="col-md-1"></div>
                <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Head count Firm
                </div>
                <div class="col-md-1"></div>
              </div>
              </div>
              <div class="col-md-4 cardHeader">
                <div class="row pb-2">
                  <div class="col-md-1"></div>
                  <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Head count Pune
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </div>
            </div>
  
            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Employees</div>
 
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ employeeFirmCount || 0}}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ employeePuneCount || 0 }}
                </span>
              </div>
            </div>
  
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Articles</div>
             
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ articleFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ articlePuneCount || 0 }}
                </span>
              </div>
              
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Consultants</div>
              
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ consultantFirmCount || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ consultantPuneCount || 0 }}
                </span>
              </div>
              
            </div>
          </div>
          </div>
      </div>
    </div>   -->

    <div class="row">
      <!-- <div class="col-md-6" *ngIf="!checkPartnerRole || userRole!='Article'">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader"> PY</div>
              <div class="col-md-4 cardHeader">CY</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Clients</div>
              <div class="col-md-4"> <span class="card-content" style="color: green;">{{totalClientsPY}}</span></div>
              <div class="col-md-4"> <span class="card-content" style="color: green;">{{totalClientsCY}}</span></div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Assignments</div>
              <div class="col-md-4"> <span class="card-content" style="color: green;">{{totalAssignmentsPY }}</span>
              </div>
              <div class="col-md-4"> <span class="card-content" style="color: green;">{{totalAssignmentsCY}}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-2">
        <div class="card cardStyle1">
          <div class="card-body align-items-start">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Balance leave
              </div>
            </div>

            <div class="row mt-3" routerLink="/dashboard/my-leaves">
              <div class="col-md-12" style="text-align: center;">
                <span class="card-content" style="color:#17a2b8">{{leaveBalanceCount}}</span>&nbsp;
                <span>Days</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-2" *ngIf="checkPartnerRole">
        <div class="card cardStyle1">
          <div class="card-body align-items-start">
            <div class="row">
              <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
              <div class="col-md-9 cardHeader">&nbsp;
                Overtime Paid
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-md-12" style="text-align: center;">
                <span class="card-content" style="color:darkviolet">{{overtimePaid| number: '2.'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="col-md-6" *ngIf="!checkPartnerRole && hasAccess('Users Mandays')">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-4"></div>
              <div class="col-md-4 cardHeader">2024 - 2025</div>
              <div class="col-md-4 cardHeader">2023 - 2024</div>
            </div>

            <div class="row" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Man Days On Clients </div>
              <!-- <div class="col-md-4" > <span class="card-content" style="color: green;">{{manDaysClientsCY}}</span></div>
            <div class="col-md-4" > <span class="card-content" style="color: green;">{{manDaysClientsPY  }}</span></div> -->
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ manDaysClientsCY || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ manDaysClientsPY || 0 }}
                </span>
              </div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-4 cardHeader">Man Days On PGB </div>
              <!-- <div class="col-md-4" > <span class="card-content" style="color: green;">{{mandaysPgbCY }}</span></div>
            <div class="col-md-4" > <span class="card-content" style="color: green;">{{mandaysPgbPY}}</span></div> -->
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ mandaysPgbCY || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color: green;">
                  {{ mandaysPgbPY || 0 }}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row pt-2">
    <div class="col-md-12" >
      <div class="card cardStyle1">
        <div class="card-body align-items-start ">
          <div class="row" style="text-align: center;">
            <div class="col cardHeader">Partner Name</div>
            <div class="col cardHeader">Budgeted Fees</div>
            <div class="col cardHeader">Budgeted Cost</div>
            <div class="col cardHeader">Budgeted Contribution %</div>
            <div class="col cardHeader">Actual Reciept</div>
            <div class="col cardHeader">Actual Cost</div>
            <div class="col cardHeader">Actual Contribution %</div>
          </div>

          <div *ngFor="let data of contributionsList ; index as i"
          id="branch_{{ i + 1 }}" class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
           
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.name}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.fees| number: '2.'}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.budgetedCost | number: '2.'}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.budgetedContributionPercentage| number: '2.'}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.actualFees| number: '2.'}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.actualCost| number: '2.'}}
              </span>
            </div>
            <div class="col">
              <span class="card-content" style="text-align: center; font-size: medium; color:#800000">
                {{data.actualContributionPercentage| number: '2.'}}
              </span>
            </div>
          </div>

          
        </div>
        </div>
  </div>  
  </div> -->
    <div class="row pt-2" *ngIf="showDashboard || userRole=='Partner'">
      <!-- <div class="col-md-12" style="height:'210px'">
        <div class="card cardStyle3">
          <div class="card-body align-items-start">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader" style=" background-color: white; color: #800000; ">Performance</div>
            </div>
            <div class="col-md-12" style="overflow-y: auto; height: 420px;">
              <table class="table table-striped table-sm table-bordered mt-1">
                <thead class="" style="top: 0; position: sticky;">
                  <tr>
                    
                    <th scope="col" style="font-size: small;">Year</th>
                    <th scope="col" style="font-size: small;">Budgeted Fees</th>
                    <th scope="col" style="font-size: small;">Budgeted Cost</th>
                    <th scope="col" style="font-size: small;">Budgeted Contribution %</th>
                    <th scope="col" style="font-size: small;">Actual Reciept</th>
                    <th scope="col" style="font-size: small;">Actual Cost</th>
                    <th scope="col" style="font-size: small;">Actual Contribution %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of contributionsList; index as i" id="branch_{{ i + 1 }}">
                    
                    <td ><span class="card-content" style="font-size: small; color:#800000">{{data.year}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.fees| number:
                        '2.'}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000"> {{data.budgetedCost |
                        number: '2.'}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">
                        {{data.budgetedContributionPercentage| number: '2.'}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.actualFees| number:
                        '2.'}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000"> {{data.actualCost| number:
                        '2.'}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">
                        {{data.actualContributionPercentage| number: '2.'}}</span></td>
                  </tr>

                </tbody>
              </table>
            </div>



          </div>
        </div>
      </div> -->
      <div class="col-md-12" *ngIf="hasAccess('Performance')">
        <div class="card" style="text-align: center; height: 140px;">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader  headingFont" style="background-color: white; color: #800000;">&nbsp;
              Performance
            </div>
            <div class="row col-md-12 m-0 p-0 ">
              <div class="col-md-12" style="height: 115px;">
                <table class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr>
                      <!-- <th *ngIf="showDashboard" scope="col" style="font-size: small;">Partner Name</th> -->
                      <th scope="col" style="font-size: small; font-weight: normal;">Year</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Budgeted Fees</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Budgeted Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Budgeted Contribution %</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Actual Reciept</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Actual Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;">Actual Contribution %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of contributionsList; index as i" id="branch_{{ i + 1 }}">
                      <!-- <td *ngIf="showDashboard"><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td> -->
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.year}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.fees | indianNumber
                          }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000"> {{data.budgetedCost |
                          indianNumber }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">
                          {{data.budgetedContributionPercentage | number: '2.' }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.actualFees|
                          indianNumber }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000"> {{data.actualCost|
                          indianNumber }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">
                          {{data.actualContributionPercentage| number: '2.' }}</span></td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row pt-2" *ngIf="showDashboard || userRole=='Partner'">
      <div class="col-md-12 mt-4" *ngIf="hasAccess('Financial Data')">
        <!-- <div class="card customCardStyle">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader">Financial data</div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Opening</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.opening }}
                </span>
              </div>
              <div class="col-md-3 cardHeader">%</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.contributionPercent | number: '2.'}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Bills Raised</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.billsRaised || 0 }}
                </span>
              </div>
              <div class="col-md-3 cardHeader">>6 Months</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.billsGreaterSixMonths || 0 }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Receipt</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.receipt || 0 }}
                </span>
              </div>
              <div class="col-md-3 cardHeader">Bad Debts</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.badDebts || 0 }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Closing</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.closing || 0 }}
                </span>
              </div>
              <div class="col-md-3 cardHeader">Credit Notes</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.creditNotes || 0 }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Employee cost</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.employeeCost || 0 }}
                </span>
              </div>
              <div class="col-md-3 cardHeader">Reimbursement</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.reimbursement || 0 }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-3 cardHeader">Contribution</div>
              <div class="col-md-3">
                <span class="card-content" style="color: green;">
                  {{ dashboardFinancials.contribution || 0 }}
                </span>
              </div>
            </div>




          </div>
        </div> -->

        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Financial Data ( {{currentYearMis.financialYear}} )
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord">
                Opening
              </div>
              <div class="col-md-2 right-border customDashbord">
                Bill Raised
              </div>
              <div class="col-md-2 right-border customDashbord">
                Receipt
              </div>
              <div class="col-md-2 right-border customDashbord">
                Closing
              </div>
              <div class="col-md-2 right-border customDashbord">
                Employee cost
              </div>
              <div class="col-md-2 right-border customDashbord">
                Contribution
              </div>

            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.opening |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.billsRaised |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.receipt |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.closing |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.employeeCost |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.contribution |
                number:'2.'}}</span>
            </div>

          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border customDashbord">
              %
            </div>
            <div class="col-md-2 right-border customDashbord">
              >6 Months
            </div>
            <div class="col-md-2 right-border customDashbord">
              Bad Debts
            </div>
            <div class="col-md-3 right-border customDashbord">
              Credit Notes
            </div>
            <div class="col-md-3 right-border customDashbord">
              Reimbursement
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{currentYearMis.dashboardFinancialsRest.contributionPercent |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{currentYearMis.dashboardFinancialsRest.billsGreaterSixMonths |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.badDebts |
                number:'2.'}}</span>
            </div>
            <div class="col-md-3 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.creditNotes |
                number:'2.'}}</span>
            </div>
            <div class="col-md-3 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.reimbursement |
                number:'2.'}}</span>
            </div>
          </div>
        </div>
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Financial Data ( {{previousYearMis.financialYear}} )
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord">
                Opening
              </div>
              <div class="col-md-2 right-border customDashbord">
                Bill Raised
              </div>
              <div class="col-md-2 right-border customDashbord">
                Receipt
              </div>
              <div class="col-md-2 right-border customDashbord">
                Closing
              </div>
              <div class="col-md-2 right-border customDashbord">
                Employee cost
              </div>
              <div class="col-md-2 right-border customDashbord">
                Contribution
              </div>

            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.opening |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.billsRaised |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.receipt |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.closing |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.employeeCost |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.contribution |
                number:'2.'}}</span>
            </div>

          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border customDashbord">
              %
            </div>
            <div class="col-md-2 right-border customDashbord">
              >6 Months
            </div>
            <div class="col-md-2 right-border customDashbord">
              Bad Debts
            </div>
            <div class="col-md-3 right-border customDashbord">
              Credit Notes
            </div>
            <div class="col-md-3 right-border customDashbord">
              Reimbursement
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{previousYearMis.dashboardFinancialsRest.contributionPercent |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{previousYearMis.dashboardFinancialsRest.billsGreaterSixMonths |
                number:'2.'}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.badDebts |
                number:'2.'}}</span>
            </div>
            <div class="col-md-3 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.creditNotes |
                number:'2.'}}</span>
            </div>
            <div class="col-md-3 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.reimbursement |
                number:'2.'}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-6">
        <div class="card customCardStyle">
          <div class="card-body align-items-start ml-4 mr-4">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader">Business Development</div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">New Clients</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.newClientsFees }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">New Assignments</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.newAssignmentsFees}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">Fee Rise</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.feesRise }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">Discontinued</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.discontinuedFees }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">Net Addition</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.netAddition }}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
              <div class="col-md-6 cardHeader">Potential</div>
              <div class="col-md-6">
                <span class="card-content" style="color: green;">
                  {{ dashboardBusiness.potentialClientsFees }}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div> -->

      <div class="col-md-12" style="margin-top: 30px;" *ngIf="hasAccess('Business Development')">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Business Development ( {{currentYearMis.financialYear}} )
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord">
                New Clients
              </div>
              <div class="col-md-2 right-border customDashbord">
                New Assignments
              </div>
              <div class="col-md-2 right-border customDashbord">
                Fee Rise
              </div>
              <div class="col-md-2 right-border customDashbord">
                Discontinued
              </div>
              <div class="col-md-2 right-border customDashbord">
                Net Addition
              </div>
              <div class="col-md-2 right-border customDashbord">
                Potential
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.newClientsFees |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.newAssignmentsFees
                | indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.feesRise |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.discontinuedFees |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.netAddition |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{currentYearMis.dashboardBusinessRest.potentialClientsFees |
                indianNumber}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" *ngIf="hasAccess('Business Development')">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Business Development ( {{previousYearMis.financialYear}} )
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord">
                New Clients
              </div>
              <div class="col-md-2 right-border customDashbord">
                New Assignments
              </div>
              <div class="col-md-2 right-border customDashbord">
                Fee Rise
              </div>
              <div class="col-md-2 right-border customDashbord">
                Discontinued
              </div>
              <div class="col-md-2 right-border customDashbord">
                Net Addition
              </div>
              <div class="col-md-2 right-border customDashbord">
                Potential
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.newClientsFees |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{previousYearMis.dashboardBusinessRest.newAssignmentsFees | indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.feesRise |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.discontinuedFees
                | indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.netAddition |
                indianNumber}}</span>
            </div>
            <div class="col-md-2 right-border">
              <span class="card-content"
                style="color:#800000">{{previousYearMis.dashboardBusinessRest.potentialClientsFees |
                indianNumber}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row pt-2" *ngIf="showDashboard ">
      <div class="col-md-12">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader" style="font-size: small; background-color: white; color: #800000; " >Administrative</div>
            </div>
            <div class="row" style="text-align: center; background-color: #800000; color: white;" >
              <div class="col cardHeader" style="font-size: small;">Head Count</div>
              <div class="col cardHeader" style="font-size: small;">Firm</div>
              <div class="col cardHeader" style="font-size: small;">Pune</div>
              <div class="col cardHeader" style="font-size: small;">Mumbai</div>
              <div class="col cardHeader" style="font-size: small;">Belagaum</div>
              <div class="col cardHeader" style="font-size: small;">Dharwad</div>
              <div class="col cardHeader" style="font-size: small;">Kolhapur</div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Employee
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Firm.employee}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Pune.employee}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Mumbai.employee}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Belgaum.employee}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Dharwad.employee}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Kolhapur.employee}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Consultant
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Firm.consultant}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Pune.consultant}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Mumbai.consultant}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Belgaum.consultant}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Dharwad.consultant}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Kolhapur.consultant}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Article
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Firm.article}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Pune.article}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Mumbai.article}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Belgaum.article}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Dharwad.article}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{headCountObj.Kolhapur.article}}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row pt-2" *ngIf="showDashboard ">
      <div class="col-md-12">
        <div class="card cardStyle1">
          <div class="card-body align-items-start ">
            <div class="row" style="text-align: center; background-color: #800000; color: white;">
              <div class="col cardHeader" style="font-size: small;">Asset Count</div>
              <div class="col cardHeader" style="font-size: small;">Firm</div>
              <div class="col cardHeader" style="font-size: small;">Pune</div>
              <div class="col cardHeader" style="font-size: small;">Mumbai</div>
              <div class="col cardHeader" style="font-size: small;">Belagaum</div>
              <div class="col cardHeader" style="font-size: small;">Dharwad</div>
              <div class="col cardHeader" style="font-size: small;">Kolhapur</div>
            </div>

            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Laptop
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Firm.laptops}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Pune.laptops}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Mumbai.laptops}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Belgaum.laptops}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Dharwad.laptops}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Kolhapur.laptops}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Assigned
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Firm.assigned}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Pune.assigned}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Mumbai.assigned}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Belgaum.assigned}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Dharwad.assigned}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Kolhapur.assigned}}
                </span>
              </div>
            </div>
            <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  Instock
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Firm.instock}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Pune.instock}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Mumbai.instock}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Belgaum.instock}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Dharwad.instock}}
                </span>
              </div>
              <div class="col">
                <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                  {{assetCountObj.Kolhapur.instock}}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->
    <div class="row mt-4 pt-2" *ngIf="showDashboard || userRole=='Partner'">
      <!-- <div class="col-md-12" style="height:'200px'">
        <div class="card cardStyle3">
          <div class="card-body align-items-start">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader" style="background-color: white; color: #800000;" >Partner Assignment and Mandays</div>
            </div>
            <div class="col-md-12" style="    overflow-y: auto; height: 420px;">

              <table style="  width: 100%;
                overflow-x: scroll;" class="table table-striped table-sm table-bordered mt-1">
                <thead class="" style="top: 0; position: sticky;">
                  <tr >
                   
                    <th colspan="4" style="text-align: center; font-size: small;"
                      *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                      {{item.year}}</th>
                
                  </tr>
                  <tr>

                    <ng-container
                      *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                      <th style="font-size: small;">
                        Clients
                      </th>
                      <th style="font-size: small;">
                        Assignments
                      </th>
                      <th style="font-size: small;">
                        Client Mandays
                      </th>
                      <th style="font-size: small;">
                        PGB Mandays
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of partnerAssignmentAndMandaysList; index as i" id="branch_{{ i + 1 }}">
                   
                    <ng-container *ngFor="let item of data.assignmentAndMandaysDtos; index as i">
                      <td><span class="card-content"
                          style="font-size: small; color:#800000">{{item.totalClients}}</span></td>
                      <td><span class="card-content"
                          style="font-size: small; color:#800000">{{item.totalAssignments}}</span></td>
                      <td><span class="card-content"
                          style="font-size: small; color:#800000">{{item.mandaysClients}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{item.mandaysPGB}}</span>
                      </td>
                    </ng-container>
                  
                  </tr>

                </tbody>
              </table>

            </div>



          </div>
        </div>
      </div> -->
      <div class="col-md-12" && *ngIf="hasAccess('Partners Assignments and Mandays')">
        <div class="card" style="text-align: center; height: 140px;">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
            <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
              Partner Assignment and Mandays
            </div>
            <div class="row col-md-12 m-0 p-0 ">
              <div class="col-md-12" style="    overflow-y: auto; height: 115px;">
                <!-- <ng-container *ngFor="let data of partnerAssignmentAndMandaysList; index as i">
                <ng-container *ngFor="let item of data.assignmentAndMandaysDtos; index as i"> -->
                <table style="  width: 100%;
                  overflow-x: scroll;" class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr>
                      <!-- <th *ngIf="showDashboard " rowspan="2" style="vertical-align: inherit; text-align: center; font-size: small;"  scope="col">Partner Name</th> -->
                      <th colspan="4" style="text-align: center; font-size: small;"
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        {{item.year}}</th>
                      <!-- <th scope="col">Budgeted Fees</th>
                        <th scope="col">Budgeted Cost</th>
                        <th scope="col">Budgeted Contribution %</th>
                        <th scope="col">Actual Reciept</th>
                        <th scope="col">Actual Cost</th>
                        <th scope="col">Actual Contribution %</th> -->
                    </tr>
                    <tr>

                      <ng-container
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        <th style="font-size: small; font-weight: normal;    ">
                          Clients
                        </th>
                        <th style="font-size: small; font-weight: normal;    ">
                          Assignments
                        </th>
                        <th style="font-size: small; font-weight: normal;    ">
                          Client Mandays
                        </th>
                        <th style="font-size: small; font-weight: normal;    ">
                          PGB Mandays
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of partnerAssignmentAndMandaysList; index as i" id="branch_{{ i + 1 }}">
                      <!-- <td *ngIf="showDashboard "><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td> -->
                      <ng-container *ngFor="let item of data.assignmentAndMandaysDtos; index as i">
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalClients}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalAssignments}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.mandaysClients}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.mandaysPGB}}</span>
                        </td>
                      </ng-container>
                      <!-- <td><span class="card-content" style="font-size: small; color:#800000">{{data.fees| number: '2.'}}</span></td>
                        <td><span class="card-content" style="font-size: medium; color:#800000"> {{data.budgetedCost | number: '2.'}}</span></td>
                        <td><span class="card-content" style="font-size: medium; color:#800000"> {{data.budgetedContributionPercentage| number: '2.'}}</span></td>
                        <td><span class="card-content" style="font-size: medium; color:#800000">{{data.actualFees| number: '2.'}}</span></td>
                        <td><span class="card-content" style="font-size: medium; color:#800000"> {{data.actualCost| number: '2.'}}</span></td>
                        <td><span class="card-content" style="font-size: medium; color:#800000"> {{data.actualContributionPercentage| number: '2.'}}</span></td> -->
                    </tr>

                  </tbody>
                </table>
                <!-- </ng-container>
  
              </ng-container> -->


              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Training Hours Balance  -->
    <div class="row mt-4 pt-2" *ngIf="userRole=='Partner' && hasAccess('Training Hours')">
      <div class="col-md-6">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-user-times" style="color:#800000"></i></div>
            <div class="col-md-9 cardHeader headingFont" style=" background-color: white; color: #800000; ">&nbsp;
              Training Hours(Balance : {{currentYearMis.financialYear}})
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4 right-border customDashbord">
                PGB as presenter
              </div>
              <div class="col-md-4 right-border customDashbord">
                PGB Internal
              </div>
              <div class="col-md-4 right-border customDashbord">
                CPE
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ currentYearMis.misTrainingReportRest.pgbPresenterBalance || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ currentYearMis.misTrainingReportRest.pgbInternelBalance || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ currentYearMis.misTrainingReportRest.cpeBalance || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card" style="text-align: center">
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"><i class="fa fa-user-times" style="color:#800000"></i></div>
            <div class="col-md-9 cardHeader headingFont" style=" background-color: white; color: #800000; ">&nbsp;
              Training Hours(Balance : {{previousYearMis.financialYear}})
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4 right-border customDashbord">
                PGB as presenter
              </div>
              <div class="col-md-4 right-border customDashbord">
                PGB Internal
              </div>
              <div class="col-md-4 right-border customDashbord">
                CPE
              </div>
            </div>
          </div>
          <div class="row col-md-12 m-0 p-0 border">
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ previousYearMis.misTrainingReportRest.pgbPresenterBalance || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ previousYearMis.misTrainingReportRest.pgbInternelBalance || 0 }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="card-content" style="color:#800000">
                {{ previousYearMis.misTrainingReportRest.cpeBalance || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>